/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Scope_Output5Inputs */

const en_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product map`)
};

const ar_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة المنتج`)
};

const bn_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাক্ট ম্যাপ`)
};

const de_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktkarte`)
};

const es_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de productos`)
};

const fr_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte des produits`)
};

const pt_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa do produto`)
};

const zh_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品图`)
};

const tr_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün haritası`)
};

const ru_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта товара`)
};

const pl_svc_full_stack_web_apps_scope_output5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa produktów`)
};

/**
* | output |
* | --- |
* | "Product map" |
*
* @param {Svc_Full_Stack_Web_Apps_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_scope_output5 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_scope_output5(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_scope_output5(inputs)
	return en_svc_full_stack_web_apps_scope_output5(inputs)
});
export { svc_full_stack_web_apps_scope_output5 as "svc_full-stack-web-apps_SCOPE_output" }